import { render, staticRenderFns } from "./CustomButtonFour.vue?vue&type=template&id=c408115c&"
import script from "./CustomButtonFour.vue?vue&type=script&lang=js&"
export * from "./CustomButtonFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports